/** @file Reference check shared by validateDoc rules: NOT_FOUND when an id is missing or of another kind. */
import type { Doc } from './schema';
import type { EntityKind } from './entityKinds';
import { docIndex } from './docIndex';
import { makeError, type Pose2DError } from '../pose2dError';

/** Records a NOT_FOUND error at `path` unless `id` is an existing entity of `kind`. */
export type NeedRef = (id: string, kind: EntityKind, path: string) => void;

/** Builds the `need` check over one document; errors are appended to `out`. */
export function refChecker(doc: Doc, out: Pose2DError[]): NeedRef {
  const index = docIndex(doc);
  return (id, kind, path) => {
    if (index.kindOf.get(id) !== kind) out.push(makeError('NOT_FOUND', { kind, ref: id }, { path }));
  };
}
